export default {
    data() {
        return {
            citys: [],
            table: 'zj',
            datas: {
                add: {
                }
            },
            r: {
                is_good: 0
            }
        };
    },

    computed: {
        disabled() {
            if (!this.r.id) {
                return false;
            }
            if (this.vuex_admin.admin_group_id == 1) {
                return false;
            }
            if (this.r.admin_id == this.vuex_admin.id) {
                return false;
            }
            return true;
        }
    },
    created() {
        this._admins([3]);
        this._load();
        this._citys();
    },
    methods: {
        _row_click(row) {


            console.log(row);

            this.$emit('row_click', row);

        },
        _citys() {

            this.$http.post('city/list', {
                limit: 1000
            }).then(res => {
                if (res.code) {
                    this.citys = res.data.data;
                }
            })
        }
    },
};